import { atom } from 'jotai'

export const showCompanySignUpDialogAtom = atom({ visible: false, firstName: '' })
